import script from "./LilaChatOutcome.vue?vue&type=script&setup=true&lang=js"
export * from "./LilaChatOutcome.vue?vue&type=script&setup=true&lang=js"

import "./LilaChatOutcome.vue?vue&type=style&index=0&id=35e0161d&lang=css"

const __exports__ = script;

export default __exports__